export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#f5ede0] py-10 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="bg-[#3a2e1e] rounded-2xl px-8 md:px-12 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
            {/* Brand */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <img
                  src="https://static.readdy.ai/image/9d8cfb7979fc745e2d4072c466ad6183/536a20549f5172b8a6a9120f71db9d15.jpeg"
                  alt="Celeste Tarot"
                  className="w-10 h-10 rounded-full object-cover"
                />
                <span className="text-[#C9A84C] font-semibold text-lg" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  Celeste Tarot
                </span>
              </div>
              <p className="text-[#c8b89a] text-sm leading-relaxed max-w-xs">
                Lecturas de tarot profesionales para guiar tu camino con honestidad, empatía y claridad.
              </p>
              <div className="flex gap-3 mt-6">
                <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-full border border-[#C9A84C]/40 text-[#C9A84C] hover:bg-[#C9A84C]/15 transition-colors duration-200 cursor-pointer">
                  <i className="ri-instagram-line text-sm"></i>
                </a>
                <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-full border border-[#C9A84C]/40 text-[#C9A84C] hover:bg-[#C9A84C]/15 transition-colors duration-200 cursor-pointer">
                  <i className="ri-facebook-line text-sm"></i>
                </a>
                <a href="https://wa.me/34643657183" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full border border-[#C9A84C]/40 text-[#C9A84C] hover:bg-[#C9A84C]/15 transition-colors duration-200 cursor-pointer">
                  <i className="ri-whatsapp-line text-sm"></i>
                </a>
              </div>
            </div>

            {/* Nav Links */}
            <div>
              <p className="text-[#9a8a75] text-xs uppercase tracking-widest mb-5">Navegación</p>
              <ul className="flex flex-col gap-3">
                {[
                  { label: "Inicio", href: "#inicio" },
                  { label: "Sobre mí", href: "#sobre-mi" },
                  { label: "Servicios", href: "#servicios" },
                  { label: "Preguntas frecuentes", href: "#preguntas-frecuentes" },
                  { label: "Testimonios", href: "#testimonios" },
                  { label: "Contacto", href: "#contacto" },
                ].map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                      className="text-[#c8b89a] hover:text-[#C9A84C] text-sm transition-colors duration-200 cursor-pointer underline-offset-2 hover:underline"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <p className="text-[#9a8a75] text-xs uppercase tracking-widest mb-5">Contacto</p>
              <div className="flex flex-col gap-3">
                <a href="tel:+34643657183" className="text-[#c8b89a] hover:text-[#C9A84C] text-sm transition-colors duration-200 cursor-pointer">
                  +34 643 65 7183
                </a>
                <a href="https://wa.me/34643657183" target="_blank" rel="nofollow noopener noreferrer" className="text-[#c8b89a] hover:text-[#C9A84C] text-sm transition-colors duration-200 cursor-pointer">
                  WhatsApp disponible
                </a>
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="border-t border-[#C9A84C]/15 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-[#9a8a75] text-xs">
              © 2026 Celeste Tarot. Todos los derechos reservados.
            </p>
            <div className="flex gap-5">
              <a href="#" rel="nofollow" className="text-[#9a8a75] hover:text-[#C9A84C] text-xs transition-colors duration-200 cursor-pointer underline">
                Política de privacidad
              </a>
              <a href="#" rel="nofollow" className="text-[#9a8a75] hover:text-[#C9A84C] text-xs transition-colors duration-200 cursor-pointer underline">
                Aviso legal
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
